import styled from 'styled-components';
import { Button } from 'antd';
import { withArticle } from './subjectWords';

/**
 * Asks before an object is added (a click or a drawn box can land in the wrong place): a small card next to the
 * marker on the picture, Add (Enter) or Cancel (Escape). A new click moves the marker instead.
 */

const tk = ({ theme: t }) => t.token;

const Card = styled.div`
	position: absolute;
	z-index: 6;
	display: flex;
	flex-direction: column;
	gap: ${p => tk(p).marginXS}px;
	width: ${p => tk(p).controlHeight * 6}px;
	padding: ${p => tk(p).paddingXS}px;
	border-radius: ${p => tk(p).borderRadiusLG}px;
	background: ${p => tk(p).panelGlassBg};
	border: ${p => `${tk(p).lineWidth}px ${tk(p).lineType} ${tk(p).colorBorder}`};
	box-shadow: ${p => tk(p).boxShadowSecondary};
	color: ${p => tk(p).colorTextLightSolid};
	font-size: ${p => tk(p).fontSizeXS}px;
`;

const Note = styled.div`
	color: ${p => tk(p).colorTextTertiary};
	font-size: ${p => tk(p).fontSizeXXS}px;
	line-height: ${p => tk(p).lineHeightSM};
`;

const Buttons = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${p => tk(p).marginXS}px;
`;

const WIDTH = 220;
const HEIGHT = 120;

const ConfirmAdd = ({ at, subject, onAdd, onCancel }) => {
	if (!at) return null;
	const style = {
		left: Math.max(8, at.x + 16 + WIDTH > at.width ? at.x - 16 - WIDTH : at.x + 16),
		top: Math.max(8, Math.min(at.y - 20, at.height - HEIGHT - 8)),
	};
	return (
		<Card
			style={style}
			role="dialog"
			aria-label={`Add ${withArticle(subject)}`}
			onPointerDown={e => e.stopPropagation()}>
			<div>Add {withArticle(subject)} here?</div>
			<Note>
				It is then followed back and forth through the video. Click elsewhere to move it.
			</Note>
			<Buttons>
				<Button onClick={onCancel}>Cancel</Button>
				<Button type="primary" autoFocus onClick={onAdd}>
					Add ↵
				</Button>
			</Buttons>
		</Card>
	);
};

export default ConfirmAdd;
